export const useAuth = () => {
  const token = localStorage.getItem("authToken");
  const user = JSON.parse(localStorage.getItem("user") || "null");

  return {
    token,
    user,
    isAuthenticated: !!token,
    isVerified: user?.is_verified,
  };
};
